// extracted by mini-css-extract-plugin
export default {"container":"category_container__Yn22o","header":"category_header__YcnQR","category":"category_category__Q3lZF"};